export default __webpack_public_path__ + "static/media/nebulizer.25b77c7b.jpg";